export default "__VITE_ASSET__DotFnm5e__"